export default __webpack_public_path__ + "static/media/analog_3_Pin_Input@2x.24facd52.png";